import React from 'react';
//import logo from './logo.svg';
//import {Counter} from './features/counter/Counter';
import {Router, Route, Switch, Redirect} from 'react-router-dom';
import {Login} from './components/login/Login';
import {useSelector} from 'react-redux';
import {DEFAULT_PAGE, MAIN_PAGE} from './constants/app-constants';

import {userSelector} from './redux/user';

import DisplayAlert from './components/common/DisplayAlert';
import DisplayLoader from './components/common/DisplayLoader';
import ConfirmDialog from './components/common/ConfirmDialog';
import MainLayout from './components/main-layout/MainLayout';
import Activate from './components/login/Activate';
import ChangePassword from './components/login/ChangePassword';

import { createBrowserHistory } from "history";

import './App.css';

export const history = createBrowserHistory();

/*function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <Counter />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <span>
          <span>Learn </span>
          <a
            className="App-link"
            href="https://reactjs.org/"
            target="_blank"
            rel="noopener noreferrer"
          >
            React
          </a>
          <span>, </span>
          <a
            className="App-link"
            href="https://redux.js.org/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Redux
          </a>
          <span>, </span>
          <a
            className="App-link"
            href="https://redux-toolkit.js.org/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Redux Toolkit
          </a>
          ,<span> and </span>
          <a
            className="App-link"
            href="https://react-redux.js.org/"
            target="_blank"
            rel="noopener noreferrer"
          >
            React Redux
          </a>
        </span>
      </header>
    </div>
  );
}*/

// https://reactrouter.com/web/example/auth-workflow
export function PrivateRoute({children, ...rest}) {
  const {token} = useSelector(userSelector);
  return (
    <Route
      {...rest}
      render={({location}) => token ? (children) : (
        <Redirect
          to={{
            pathname: DEFAULT_PAGE,
            state: { from: location }
          }}
          />
      )}
    />
  )
};

function App() {
  return (
    <Router history={history}>
      {/*<div>qwe</div>*/}
      <Switch>
        <Route exact path={DEFAULT_PAGE}> <Login/> </Route>
        <PrivateRoute path={MAIN_PAGE}>
          <MainLayout />
        </PrivateRoute>
        <Route path="/test1">
          <div>test1</div>
        </Route>
        <Route path={`${DEFAULT_PAGE}/activate`}>
          <Activate/>
        </Route>
        <Route path={`${DEFAULT_PAGE}/restorePassword`}>
          <ChangePassword/>
        </Route>
        <Route>
          <Redirect to={{pathname: DEFAULT_PAGE}}/>
        </Route>
      </Switch>
      <DisplayAlert/>
      <DisplayLoader/>
      <ConfirmDialog/>
    </Router>
  )
}

export default App;
